import { api } from '@/api/axiosInstance';
import { PostPartnerConfirmFileRequest } from '../type/types';
import { ApiResponseType, CONFIRMATION_FILE_TYPE } from '../type/commonTypes';

export const postPartnerConfirmFile = async (
  data: PostPartnerConfirmFileRequest
) => {
  const res = await api.post<ApiResponseType<CONFIRMATION_FILE_TYPE[]>>(
    '/api/web/partners/orders/confirm',
    data
  );
  return res.data;
};
